import { format, getTime, formatDistanceToNow } from 'date-fns';
import moment from "jalali-moment";

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export function convertDateTimeToServerFormat(date) {
  try {
    const result = moment(date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    return result === 'Invalid date' ? '' : result
  } catch (e) {
    return ''
  }
}

export function convertTimeToCompleteDate(date) {
  try {
    const result = moment(date, 'HH:mm').format('YYYY-MM-DDTHH:mm:ss');
    return result === 'Invalid date' ? '' : result
  } catch (e) {
    return ''
  }
}

export function convertTimeToServerFormat(time) {
  try {
    const result = moment(time,'YYYY-MM-DDTHH:mm:ss').format('HH:mm:ss');
    return result === 'Invalid date' ? '' : result
  } catch (e) {
    return ''
  }
}
export function convertDateToServerFormat(date) {
  try {
    const result =  moment(date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
    return result === 'Invalid date' ? '' : result
  } catch (e) {
    return ''
  }
}

export function fDateJalali(date) {
  try {
    const result = moment(date, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('YYYY/MM/DD');
    return result === 'Invalid date' ? '' : result
  } catch (e) {
    return ''
  }
}

export function fDateTimeJalali(date) {
  try {
    const result = moment(date, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm YYYY/MM/DD');
    return result === 'Invalid date' ? '' : result
  } catch (e) {
    return ''
  }
}

export function fTimeJalali(date) {
  try {
    const result = moment(date, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm');
    return result === 'Invalid date' ? '' : result
  } catch (e) {
    return ''
  }
}
